var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRocketLaunch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.57692 10.0002L5.5 7.92325M7.57692 10.0002C8.54397 9.63238 9.47169 9.16852 10.3462 8.61556M7.57692 10.0002V13.4617C7.57692 13.4617 9.67462 13.0809 10.3462 12.0771C11.0938 10.9556 10.3462 8.61556 10.3462 8.61556M5.5 7.92325C5.86841 6.96747 6.3323 6.05129 6.88462 5.18863C7.69128 3.89885 8.81451 2.8369 10.1475 2.10377C11.4804 1.37065 12.9788 0.990736 14.5 1.00017C14.5 2.88325 13.96 6.19248 10.3462 8.61556M5.5 7.92325H2.03846C2.03846 7.92325 2.41923 5.82556 3.42308 5.15402C4.54462 4.40633 6.88462 5.15402 6.88462 5.15402M2.38462 11.0386C1.34615 11.9109 1 14.5002 1 14.5002C1 14.5002 3.58923 14.154 4.46154 13.1156C4.95308 12.534 4.94615 11.6409 4.39923 11.1009C4.13014 10.8441 3.77566 10.6957 3.40385 10.6842C3.03203 10.6727 2.66907 10.7989 2.38462 11.0386Z",
    stroke: "#25324B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketLaunch);
export default __webpack_public_path__ + "static/media/rocket-launch.a39016c8cfe5ef4093ec7ce8f465e43e.svg";
export { ForwardRef as ReactComponent };